import type { ReactNode } from 'react';

interface AsyncBoundaryProps {
  loading: boolean;
  error: Error | null;
  onRetry?: () => void;
  /** Quando true (e não há erro/carregando), mostra o estado vazio. */
  isEmpty?: boolean;
  emptyMessage?: ReactNode;
  children: ReactNode;
}

/**
 * Centraliza a apresentação dos estados carregando / erro / vazio de uma
 * requisição, renderizando `children` apenas quando há dados.
 */
export function AsyncBoundary({
  loading,
  error,
  onRetry,
  isEmpty,
  emptyMessage,
  children,
}: AsyncBoundaryProps): React.JSX.Element {
  if (loading) {
    return (
      <div className="state" role="status" aria-live="polite">
        <div className="spinner" aria-hidden />
        <span>Carregando…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="state" role="alert">
        <div className="err-title">Não foi possível carregar os dados</div>
        <p>{error.message}</p>
        {onRetry && (
          <button type="button" className="btn" onClick={onRetry}>
            Tentar novamente
          </button>
        )}
      </div>
    );
  }

  if (isEmpty) {
    return <div className="state">{emptyMessage ?? 'Nada encontrado.'}</div>;
  }

  return <>{children}</>;
}
